module.exports = __webpack_public_path__ + "static/media/washington-state-university.ba267ee2.png";